import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const staticPagesService = createApi({
  reducerPath: 'staticPagesService',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetStaticPage: builder.query<any, any>({
      query: ({pageId, language = CURRENT_LANGUAGE}) => `web/page?pageId=${pageId}&locale=${language}`,
    }),
    GetStaticPageByPublicCode: builder.query<any, any>({
      query: ({code, language = CURRENT_LANGUAGE}) => `web/page/code?publicCode=${code}&locale=${language}`,
    }),
  }),
});

export const {
  useLazyGetStaticPageQuery,
  useLazyGetStaticPageByPublicCodeQuery,
} = staticPagesService;
